import Icon from '../components/Icon.vue'

Icon.register({
  film: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 64H480V84C480 90.6 474.6 96 468 96H428C421.4 96 416 90.6 416 84V64H96V84C96 90.6 90.6 96 84 96H44C37.4 96 32 90.6 32 84V64H24C10.7 64 0 74.7 0 88V424C0 437.3 10.7 448 24 448H32V428C32 421.4 37.4 416 44 416H84C90.6 416 96 421.4 96 428V448H416V428C416 421.4 421.4 416 428 416H468C474.6 416 480 421.4 480 428V448H488C501.3 448 512 437.3 512 424V88C512 74.7 501.3 64 488 64zM96 372C96 378.6 90.6 384 84 384H44C37.4 384 32 378.6 32 372V332C32 325.4 37.4 320 44 320H84C90.6 320 96 325.4 96 332V372zM96 276C96 282.6 90.6 288 84 288H44C37.4 288 32 282.6 32 276V236C32 229.4 37.4 224 44 224H84C90.6 224 96 229.4 96 236V276zM96 180C96 186.6 90.6 192 84 192H44C37.4 192 32 186.6 32 180V140C32 133.4 37.4 128 44 128H84C90.6 128 96 133.4 96 140V180zM368 388C368 394.6 362.6 400 356 400H156C149.4 400 144 394.6 144 388V292C144 285.4 149.4 280 156 280H356C362.6 280 368 285.4 368 292V388zM368 220C368 226.6 362.6 232 356 232H156C149.4 232 144 226.6 144 220V124C144 117.4 149.4 112 156 112H356C362.6 112 368 117.4 368 124V220zM480 372C480 378.6 474.6 384 468 384H428C421.4 384 416 378.6 416 372V332C416 325.4 421.4 320 428 320H468C474.6 320 480 325.4 480 332V372zM480 276C480 282.6 474.6 288 468 288H428C421.4 288 416 282.6 416 276V236C416 229.4 421.4 224 428 224H468C474.6 224 480 229.4 480 236V276zM480 180C480 186.6 474.6 192 468 192H428C421.4 192 416 186.6 416 180V140C416 133.4 421.4 128 428 128H468C474.6 128 480 133.4 480 140V180z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/film.js
// module id = YgdJ
// module chunks = 144